// 2) Third-party library imports
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { get } from 'lodash-es';

// 3) Local imports
// 3.1 Constants
import { API_NAME } from '../../config/config';
import { _queries as queries } from '../../graphql/queries.graphql';

// 3.4 Utility functions / types
import client, { post } from 'src/api';
import { DynamicObject } from '../../utils/commonInterfaces';

import {
    getSmsCustomizationProviderFailAction,
    getSmsCustomizationProviderRequestAction,
    getSmsCustomizationProviderSuccessAction,
    saveSmsCustomizationProviderRequestAction,
    saveSmsCustomizationProviderResponseAction,
} from './smsProvidersSlice';

function* handleGetSmsProviderRequest() {
    try {
        // To call async functions, use redux-saga's `call()`.
        const res: DynamicObject = yield call(
            [client, client.graphql],
            {
                query: queries.GET_SMS_CUSTOMIZATION_PROVIDER,
            }
        );

        if (res.error) {
            console.log('res.error', res.error);
            yield put(getSmsCustomizationProviderFailAction())
        } else {
            const { GetSmsCustomizationProvider } = res.data;
            yield put(getSmsCustomizationProviderSuccessAction(GetSmsCustomizationProvider));
        }
    } catch (err) {
        if (err instanceof Error) {
            console.log('Error', err);
        } else {
            console.error('An unknown error occured.');
        }
    }
}

/**
 * Function called for saving data.
 */
function* handleSaveSmsProviderRequest({ payload: sagaPayload }: any) {
    const { SmsCustomization, callback } = sagaPayload;
    try {
        yield call(post,
            {
                apiName: API_NAME,
                path: '/company/smscustomizationprovider/save',
                options: {
                    body: SmsCustomization,
                }
            }
        );

        yield put(saveSmsCustomizationProviderResponseAction());

        if (callback) {
            const response = {
                IsSuccess: true,
            };

            callback(response);
        }
        // calls for queries if needed
    } catch (err) {
        yield put(saveSmsCustomizationProviderResponseAction());
        if (callback) {
            const returnData = get(err.response, 'data')
                ? err.response.data
                : { Messages: [err.message] };
            returnData.IsSuccess = false;
            callback(returnData);
        }
        if (err instanceof Error) {
            console.log('Error', err);
        } else {
            console.error('An unknown error occured.');
        }
    }
}

// This is our watcher function. We use `take*()` functions to watch Redux for a specific action
// type, and run our saga, for example the `handleFetch()` saga above.
function* watchGetSmsProviderRequest() {
    yield takeLatest(
        getSmsCustomizationProviderRequestAction.type,
        handleGetSmsProviderRequest
    );
}

function* watchSaveUserCompanyRequest() {
    yield takeLatest(
        saveSmsCustomizationProviderRequestAction.type,
        handleSaveSmsProviderRequest
    );
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* smsProvidersSaga() {
    yield all([fork(watchGetSmsProviderRequest)]);
    yield all([fork(watchSaveUserCompanyRequest)]);
}

export default smsProvidersSaga;
